/**
 * @export
 * @class @class CustomerSatisfaction
 * 판매자 품질 만족지수 (상품 만족, 배송 만족)
 */
export default class CustomerSatisfaction {
  constructor() {
    this.sWrapper = '_customerSatisfaction';
    this.welWrapper = $(`#${this.sWrapper}`);
    this.render();
  }

  render() {
    const {
      customerSatisfaction: {
        data: { dealReviewPoint, deliveryReviewPoint } = {},
      } = {},
    } = TMON.oApp.htStorage;
    const { bIsDeliveryDeal } = TMON.htStaticData;

    // 리뷰가 없는 경우 0점 (해당 영역 노출하지 않음)
    if (!dealReviewPoint && !deliveryReviewPoint) {
      this.hide();
      return;
    }

    const sHtml = `<div class="customer_satisfaction_left">
              <span class="customer_satisfaction_title">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
                    <g fill="none" fill-rule="evenodd">
                        <path fill="#FFF" stroke="#7D7E80" d="M15.212 10.499l3.808 6.682-3.759-.285-1.648 3.444-3.806-6.68 5.405-3.161z"></path>
                        <path fill="#FFF" stroke="#7D7E80" d="M4.788 10.499L.98 17.18l3.759-.285 1.648 3.444 3.806-6.68L4.788 10.5z"></path>
                        <ellipse cx="9.548" cy="7.792" fill="#FFF" stroke="#7D7E80" rx="7.19" ry="7.292"></ellipse>
                        <path fill="#7D7E80" fill-rule="nonzero" d="M7.123 7.436L6.381 8.226 8.882 10.598 12.817 5.9 12.012 5.178 8.791 9.05z"></path>
                    </g>
                  </svg>
                  판매자 품질 만족지수
              </span>
              ${
                TMON.oApp.sPlatform === 'PW'
                  ? `<div class="customer_satisfaction_tip">
                      <div class="default_tip">
                          <span class="btn_help_tip">
                              추가 정보
                          </span>
                          <div class="pop_tooltip_sale">
                              <div class="inner">
                                  <p class="txt">이 상품의 판매자가 판매중인 상품 리뷰의 상품${
                                    bIsDeliveryDeal ? '/배송' : ''
                                  } 평균 만족도입니다.</p>
                              </div>
                          </div>
                      </div>
                  </div>`
                  : ''
              }
          </div>
          <div class="customer_satisfaction_right">
            <dl class="customer_satisfaction_list">
                <div class="customer_satisfaction_box">
                  <dt>상품</dt>
                  <dd><span class="num">${dealReviewPoint}</span>점</dd>
                </div>
            ${
              bIsDeliveryDeal
                ? `<div class="customer_satisfaction_box">
                    <dt>배송</dt>
                    <dd><span class="num">${deliveryReviewPoint}</span>점</dd>
                </div>`
                : ''
            }
            </dl>
          </div>
          `;
    this.welWrapper.append(sHtml);
  }

  hide() {
    this.welWrapper.hide();
  }
}
